import React from 'react';
import clsx from 'clsx';
import styles from './LoadingSpinner.module.css';

type Props = {
  className?: string;
  variant?: 'dark';
};
export const LoadingSpinner: React.FunctionComponent<Props> = ({
  className,
  variant,
}) => {
  return (
    <div
      className={clsx(styles.LoadingSpinner, className, {
        [styles.greySpinner]: variant === 'dark',
      })}
    >
      Loading...
    </div>
  );
};
